import styled from 'styled-components';
import { colours, maxWidthPartial, media, spacing } from '../../../stylings';

export const RatingSummary = styled.div`
  &:not(:has(.trustpilot-widget iframe[style*='display: block'])) {
    display: none;
    min-height: 0;
  }
  margin: 0;
  min-height: 20px;

  @media ${media.greaterThan('lg')} {
    padding-top: ${spacing.S};
  }
`;

export const RatingsAndReviews = styled.div`
  ${maxWidthPartial({ withPaddingXL: true })}

  &:has(.trustpilot-widget iframe[style*='display: none']) {
    display: none;
    min-height: 0;
  }

  @media ${media.greaterThan('lg')} {
    border: 1px ${colours.BLACK};
    border-style: solid none;
    margin: 80px auto;
    padding: ${spacing.S};
  }
`;
